// // Layout.js
// import React from "react";
// import { Outlet } from "react-router-dom";
// import Sidebar from "./Sidebar";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import { Box, Container } from "@mui/material";

// const Layout = () => {
//   return (
//     <Box sx={{ display: "flex", height: "100vh", flexDirection: "column" }}>
//       <Box sx={{ display: "flex", flexGrow: 1 }}>
//         <Sidebar />
//         <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
//           <Navbar />
//             <Outlet />
//       <Footer sx={{ mt: "auto" }} />
//         </Box>
//                 <Sidebar />

//       </Box>
//     </Box>
//   );
// };

// export default Layout;
// Layout.js
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Box, useMediaQuery } from "@mui/material";
import Sidebar2 from "./Sidebar2";

const Layout = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      {/* Left Sidebar */}
      <Sidebar mobileOpen={mobileNavOpen} onMobileClose={() => setMobileNavOpen(false)} />

      {/* Main content with navbar, outlet, and footer */}
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
        <Navbar onMenuClick={() => setMobileNavOpen(true)} />
        <Box sx={{ flexGrow: 1, overflow: "auto" }}>
          <Outlet />
        </Box>
        <Footer />
      </Box>

      {/* Right Sidebar (activity log) — hidden on mobile to save space */}
      {!isMobile && <Sidebar2 />}
    </Box>
  );
};

export default Layout;
